import Void from './components/Void';

export default Void;
